import styled from 'styled-components';
import { Card as AntDesignCard } from 'antd';
import { AA_SURFACE } from '~/modules/Helper/contrast.helper';

export const Card = styled(AntDesignCard)`
  && {
    background: ${AA_SURFACE};

    .ant-card-head-title,
    .ant-card-body {
      font-size: ${({ theme }) => `${16 + 2 * theme.zoomFonte}px`};
    }
  }
`;
